import { ContainerRate } from './styles';
import { RateProps, Rate } from 'antd';

export const ARate: React.FC<RateProps> = ({ ...res }) => {
  return (
    <ContainerRate>
      <Rate {...res} />
    </ContainerRate>
  );
};
